module.exports = __webpack_public_path__ + "img/GW.932b85d3.svg";